import Config from '../config';

run.$inject = [ '$rootScope', '$transitions', '$translate', '$document' ];

/**
 * @todo listen for all API 401 and navigate to login (except POST auth/access call)
 * @param {Scope} $rootScope
 * @param {TransitionService} $transitions
 * @params {$translate} $translate
 * @param $translate
 * @param $document
 */
export default function run($rootScope, $transitions, $translate, $document) {

    if (Config.FORCE_HTTPS && location.protocol !== 'https:') {

        location.replace(`https:${location.href.substring(location.protocol.length)}`);
    }

    $rootScope.app = {
        copyright: Config.COPYRIGHT,
        version: Config.APP_VERSION,
        name: Config.APP_NAME,
        short_name: Config.APP_NAME.split(' ').map((word) => word.slice(0, 1)).join('')
    };
    $rootScope.hosts = Config.HOSTS;
    $rootScope.$state = null;
    $rootScope.$lang = localStorage.getItem('lang');
    $rootScope.$sideBarState = false;
    $rootScope.$globalMenuState = false;

    if (localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {

        localStorage.setItem('lang', defaultLang());
    }

    function handleLanguageChange(language) {
        if (language === 'ar') {
            $document.find('html').attr('dir', 'rtl');
            $document.find('body').addClass('rtl');
        } else {
            $document.find('html').attr('dir', 'ltr');
            $document.find('body').removeClass('rtl');
        }
    }

    // Initial language setup
    handleLanguageChange(localStorage.getItem('lang'));

    $translate.use(localStorage.getItem('lang'));

    $transitions.onSuccess({}, (transition) => {

        $rootScope.$state = transition.$to();
    });

    $transitions.onStart( { from: 'login', to: 'dashboard' }, (trans) => {

        $translate.use(localStorage.getItem('lang'));

        $rootScope.$lang = localStorage.getItem('lang');

        handleLanguageChange(localStorage.getItem('lang'));
    });

    $transitions.onStart({}, (trans) => {
        $rootScope.$sideBarState = false;
        $rootScope.$globalMenuState = false;
    });

    // Listen for language changes
    $rootScope.$on('$translateChangeSuccess', function(event, data) {
        $rootScope.$lang = data.language;
        localStorage.setItem('lang', data.language);
        handleLanguageChange(data.language);
    });

    function defaultLang() {
        return 'en';
    }
}



// WEBPACK FOOTER //
// ./src/app-core/core.run.js